<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo -->
      <b-link class="brand-logo">
        <b-img class="d-none d-sm-block" :src="brandLogo" fluid width="50px" height="30px" />
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">{{ appName }}</h2>
      </b-link>

      <b-col lg="8" class="d-none d-lg-flex align-items-center">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img style="max-width:60%;margin:0 auto" fluid :src="brandLogo" :alt="appName" />
        </div>
      </b-col>

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">เข้าสู่ระบบสำหรับผู้ดูแลระบบ (Branch)</b-card-title>

          <validation-observer ref="loginForm" #default="{invalid}">
            <b-form class="auth-login-form mt-2" @submit.prevent="loginButton">
              <b-form-group label="Username" label-for="login-username">
                <validation-provider #default="{ errors }" name="Username" vid="username" rules="required">
                  <b-form-input id="login-username" v-model="user" :state="errors.length > 0 ? false:null" name="login-username" placeholder="Username" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null">
                    <b-form-input id="login-password" v-model="pass" :state="errors.length > 0 ? false:null" class="form-control-merge" :type="passwordFieldType" name="login-password" placeholder="Password" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button type="submit" variant="primary" block :disabled="invalid || loadButton == false" @click="loginButton()">
                <b-spinner v-if="loadButton == false" small />
                เข้าสู่ระบบ
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { taobaoService_dotnet } from '@/views/global'
import axios from 'axios'
import { token_api } from '@/views/token'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BButton, BImg, BCardTitle, BSpinner } from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required } from '@validations'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { getBrand, getBranchId } from '@/branding'

export default {
  directives: {},
  components: { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BButton, BImg, BCardTitle, BSpinner, ValidationProvider, ValidationObserver },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      profile: [],
      user: '',
      pass: '',
      loadButton: true,
      required,
      brandLogo: getBrand().logo,
      appName: getBrand().appName,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async loginButton() {
      this.loadButton = false
      try {
        var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
        var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
        this.profile = []
        let resp = await axios.post(
          taobaoService_dotnet  + 'app/Branch/branch-login',
          {
            'username': this.user,
            'password': this.pass,
            'branchId': getBranchId()
          },
          { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
        )

        await this.$refs.loginForm.validate().then(async success => {
          if (success && resp.data && resp.data.customerID != 0) {
            // Set tokens and localStorage similar to existing admin login behaviour
            this.profile = []
            this.profile.push({ data: resp.data, role: 'adminBranch', ability: [{ action: 'manage', subject: 'BranchAdmin' }] })
            useJwt.setToken(sToken)
            useJwt.setRefreshToken(rToken)
            localStorage.setItem('userData', JSON.stringify(this.profile[0]))
            // jinmatai: header_token ใช้ auth_token ของผู้ใช้ที่ login จริง (branch-login คืน JWT ในคอลัมน์ loginToken)
            if (resp.data.loginToken) localStorage.setItem('auth_token', resp.data.loginToken)
            if (resp.data.adminInfo && resp.data.adminInfo.userID) localStorage.setItem('adminId', JSON.stringify(resp.data.adminInfo.userID))
            this.$ability.update(this.profile[0].ability)
            this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', 0)
            this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))
          } else {
            this.$swal({ position: 'top', title: 'ล็อคอินไม่สำเร็จ', text: 'Username หรือ รหัสผ่านผิด', icon: 'warning', customClass: { confirmButton: 'btn btn-primary', text: 'text-danger' }, buttonsStyling: false })
          }
          this.loadButton = true
        })
      } catch (err) {
        this.loadButton = true
        this.$swal({ position: 'top', title: 'เกิดข้อผิดพลาด', text: err && err.response && err.response.data ? JSON.stringify(err.response.data) : 'ไม่สามารถติดต่อเซิร์ฟเวอร์ได้', icon: 'error', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
